module.exports = __webpack_public_path__ + "static/img/QRcode@2x.0a6e54e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/activity/MYBANK_pc/QRcode@2x.png
// module id = vgZ/
// module chunks = 69